import "./App.css";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { privateRoutes, routes, staffRoutes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import "./Assets/css/responsive.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import ErrorBoundary from "./components/ErrorBoundary";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { setAuthToken } from "./utils/axios";

function App() {
  const navigate = useNavigate();
  const { user, isLogin } = useSelector((state) => state.auth);

  console.log("is login ", isLogin);

  // useEffect(() => {
  //   if (!isLogin) {
  //     //navigate to login
  //     navigate("/login");
  //   } else {
  //     setAuthToken(user?.authToken);
  //   }
  // }, []);



  return (
    // <ErrorBoundary>
    <Routes>
      {!isLogin && (
        <Route element={<AuthLayout />}>
          <Route index element={<Navigate to="/login" />} />
          {routes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>
      )}

      {isLogin && (
        <Route element={<MainLayout />}>
          {user?.role == "Admin" ? privateRoutes.map((data, index) => (
            <>
              <Route index element={<Navigate to="/dashboard" />} />
              <Route
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
            </>
          )) : user?.role === "Staff" && staffRoutes?.map((data, index) => (
            <>
              <Route
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
              <Route path="*" element={<Navigate to="/orders" />} />
            </>
          ))}
        </Route>
      )}


    </Routes>
    // </ErrorBoundary>
  );
}

export default App;









